import { ProjectActionTypes, ProjectCountActionTypes, ProjectUsersAndGroupsActionTypes } from "./project-types";
import {
  GetProjectsWithFilters,
  GetTopTenProjectsWithFilters, // THIS Top Ten logic and endpoint not longer needed
  GetProjectsUsersAndGroups,
  GetProjectsCountByUser,
} from "../../services/api/project-api";

export const getProjectsNew = (projectQuery) => {
    return async dispatch => {
        try {
            dispatch(fetchProjectsStart());
            dispatch(setSelectedProjects([]))

            let projectsObject = null;
            let projects = null;

            projectsObject = await GetProjectsWithFilters(projectQuery);
            projects = projectsObject.data;

            dispatch(setProjects(projects));
            dispatch(setProjectQuery(projectQuery));
            dispatch(fetchProjectsSuccess());
        } catch (error) {
            dispatch(fetchProjectsFailure(error))
            console.log(error);
        }
    }
}

// THIS Top Ten logic and endpoint not longer needed
export const getTopTenProjects = (projectQuery) => {
    return async (dispatch, getState) => {
        try {
            dispatch(fetchProjectsStart());
            dispatch(setSelectedProjects([]))

            let projectsObject = null;
            let projects = null;
            let active = [];
            let completed = [];
            let archived = [];
            projectsObject = await GetTopTenProjectsWithFilters(projectQuery);

            projects = projectsObject.data;

            dispatch(setProjects(projects));
            projects.forEach(project => {
                (project.StatusId === 1) && active.push(project);
                (project.StatusId === 2) && completed.push(project);
                (project.StatusId === 0) && archived.push(project);
            });

            dispatch(setProjectsGrouped({...getState().projects.projectsGrouped, 'active': active, 'completed': completed, 'archived': archived }));
            dispatch(setProjectQuery(projectQuery));
            dispatch(fetchProjectsSuccess());
        } catch (error) {
            dispatch(fetchProjectsFailure(error))
            console.log(error);
        }
    }
}

export const getProjectsCount = () => {
    return async dispatch => {
        try {
            dispatch(fetchProjectsCountStart());

            let projectsCountObject = null;
            let projectsCount = null;
            let projectsCount1 = null;

            projectsCountObject = await GetProjectsCountByUser();
            projectsCount = projectsCountObject.data.Result;
            projectsCount1 = {
                all: projectsCount.Total,
                active: projectsCount.Active,
                completed: projectsCount.Completed,
                archived: projectsCount.Archive
            }

            dispatch(setProjectsCount(projectsCount1));
            dispatch(fetchProjectsCountSuccess());
        } catch (error) {
            dispatch(fetchProjectsCountFailure(error))
            console.log(error);
        }
    }
}

export const getProjectsUsersAndGroups = () => {
    return async dispatch => {
        try {
            dispatch(fetchProjectsUsersAndGroupsStart());

            let projectsUsersAndGroups = null;
            let projectsUsers = null;
            let projectsGroups = null;

            projectsUsersAndGroups = await GetProjectsUsersAndGroups();
            projectsUsers = projectsUsersAndGroups.data.UserMembers;
            projectsGroups = projectsUsersAndGroups.data.GroupMembers;

            dispatch(setProjectsUsers(projectsUsers));
            dispatch(setProjectsGroups(projectsGroups));
            dispatch(fetchProjectsUsersAndGroupsSuccess());
        } catch (error) {
            dispatch(fetchProjectsUsersAndGroupsFailure(error))
            console.log(error);
        }
    }
}

export const getProjectsGroupedNew = (groupBy,projectQuery,labels) => {
    return async (dispatch, getState) => {
        try {
            let projectsObject = null;
            let projects = null;

            let active = [];
            let completed = [];
            let archived = [];
            let urgent = [];
            let high = [];
            let medium = [];
            let low = [];

            dispatch(fetchProjectsStart());
            dispatch(setSelectedProjects([]))
            dispatch(setGroupProjectsBy(groupBy));

            let projectQuery = {
                userId: 0,
                sortBy: "",
                sortDesc: true,
                pageNumber: 1,
                pageSize: 1000000,
                filters:[{column: 'status', value: 'all', type: null}]
            }

            projectsObject = await GetProjectsWithFilters(projectQuery);
            projects = projectsObject.data;

            if (groupBy.toLowerCase() === 'status') {
                projects.forEach(project => {
                    (project.StatusId === 1) && active.push(project);
                    (project.StatusId === 2) && completed.push(project);
                    (project.StatusId === 0) && archived.push(project);
                });

                dispatch(setProjectsGrouped({...getState().projects.projectsGrouped, 'active': active, 'completed': completed, 'archived': archived }));
            }

            if (groupBy.toLowerCase() === 'priority') {
                projects.forEach(project => {
                    (project.Priority?.toLowerCase().includes('urgent')) && urgent.push(project);
                    (project.Priority?.toLowerCase().includes('high')) && high.push(project);
                    (project.Priority?.toLowerCase().includes('medium')) && medium.push(project);
                    (project.Priority?.toLowerCase().includes('low')) && low.push(project);
                });

                dispatch(setProjectsGrouped({...getState().projects.projectsGrouped, 'urgent': urgent, 'high': high, 'medium': medium, 'low' : low }));
            }

            if (groupBy.toLowerCase() === 'none') {
                dispatch(setProjectsGrouped({...getState().projects.projectsGrouped, 'none': projects}));
            }

            dispatch(setProjects(projects,labels));
            dispatch(fetchProjectsSuccess());
        } catch (error) {
            dispatch(fetchProjectsFailure(error));
            dispatch(resetProjects());
            console.log(error);
        }
    }
}

// THIS Top Ten logic and endpoint not longer needed
export const getTopTenProjectsGrouped = (groupBy) => {
    return async (dispatch, getState) => {
        try {
            let projectsObject = null;
            let projects = null;

            let active = [];
            let completed = [];
            let archived = [];
            let urgent = [];
            let high = [];
            let medium = [];
            let low = [];

            dispatch(fetchProjectsStart());
            dispatch(setSelectedProjects([]))
            dispatch(setGroupProjectsBy(groupBy));

            let projectQuery = {
                userId: 0,
                sortBy: "",
                sortDesc: true,
                pageNumber: 1,
                pageSize: 1000000,
                filters:[{column: 'status', value: 'all', type: null}]
            }

            projectsObject = await GetTopTenProjectsWithFilters(projectQuery);
            projects = projectsObject.data;

            if (groupBy.toLowerCase() === 'status') {
                projects.forEach(project => {
                    (project.StatusId === 1) && active.push(project);
                    (project.StatusId === 2) && completed.push(project);
                    (project.StatusId === 0) && archived.push(project);
                });

                dispatch(setProjectsGrouped({...getState().projects.projectsGrouped, 'active': active, 'completed': completed, 'archived': archived }));
            }

            if (groupBy.toLowerCase() === 'priority') {
                projects.forEach(project => {
                    (project.Priority.toLowerCase().includes('urgent')) && urgent.push(project);
                    (project.Priority.toLowerCase().includes('high')) && high.push(project);
                    (project.Priority.toLowerCase().includes('medium')) && medium.push(project);
                    (project.Priority.toLowerCase().includes('low')) && low.push(project);
                });

                dispatch(setProjectsGrouped({...getState().projects.projectsGrouped, 'urgent': urgent, 'high': high, 'medium': medium, 'low' : low }));
            }

            if (groupBy.toLowerCase() === 'none') {
                dispatch(setProjectsGrouped({...getState().projects.projectsGrouped, 'none': projects}));
            }

            dispatch(setProjects(projects));
            dispatch(fetchProjectsSuccess());
        } catch (error) {
            dispatch(fetchProjectsFailure(error));
            dispatch(resetProjects());
            console.log(error);
        }
    }
}

export const setProjectsGrouped = (projectsGrouped) => ({
    type: ProjectActionTypes.SET_PROJECTS_GROUPED,
    payload: projectsGrouped
})

export const setGroupProjectsBy = (groupBy) => ({
    type: ProjectActionTypes.SET_GROUP_PROJECTS_BY,
    payload: groupBy
})

export const fetchProjectsStart = () => ({
    type: ProjectActionTypes.FETCHING_PROJECTS_START
})

export const fetchProjectsCountStart = () => ({
    type: ProjectCountActionTypes.FETCHING_PROJECTS_COUNT_START
})

export const fetchProjectsUsersAndGroupsStart = () => ({
    type: ProjectUsersAndGroupsActionTypes.FETCHING_PROJECTS_USERS_AND_GROUPS_START
})

export const fetchProjectsSuccess = () => ({
    type: ProjectActionTypes.FETCHING_PROJECTS_SUCCESS
})

export const fetchProjectsFailure = (errorMessage) => ({
    type: ProjectActionTypes.FETCHING_PROJECTS_FAILURE,
    payload: errorMessage
})

export const fetchProjectsCountSuccess = () => ({
    type: ProjectCountActionTypes.FETCHING_PROJECTS_COUNT_SUCCESS
})

export const fetchProjectsCountFailure = (errorMessage) => ({
    type: ProjectCountActionTypes.FETCHING_PROJECTS_COUNT_SUCCESS,
    payload: errorMessage
})

export const fetchProjectsUsersAndGroupsSuccess = () => ({
    type: ProjectUsersAndGroupsActionTypes.FETCHING_PROJECTS_USERS_AND_GROUPS_SUCCESS
})

export const fetchProjectsUsersAndGroupsFailure = (errorMessage) => ({
    type: ProjectUsersAndGroupsActionTypes.FETCHING_PROJECTS_USERS_AND_GROUPS_FAILURE,
    payload: errorMessage
})

// DELETE once MVC deprecation is completed
export const setProjectCounts = (projectCounts) => ({
    type: ProjectActionTypes.SET_PROJECT_COUNTS,
    payload: projectCounts
})

export const setProjectsCount = (projectsCount) => ({
    type: ProjectCountActionTypes.SET_PROJECTS_COUNT,
    payload: projectsCount
})

export const setProjectsUsers = (projectsUsers) => ({
    type: ProjectActionTypes.SET_PROJECTS_USERS,
    payload: projectsUsers
})

export const setProjectsGroups = (projectsGroups) => ({
    type: ProjectActionTypes.SET_PROJECTS_GROUPS,
    payload: projectsGroups
})

export const setProjects = (projects, labels) => ({
    type: ProjectActionTypes.SET_PROJECTS,
    payload: projects,
    labels: labels
})

export const setProjectQuery = (projectQuery) => ({
    type: ProjectActionTypes.SET_PROJECTS_QUERY,
    payload: projectQuery
})

export const addSelectedProject = (projId) => ({
    type: ProjectActionTypes.ADD_SELECTED_PROJECT,
    payload: projId
})

export const deleteSelectedProject = (projId) => ({
    type: ProjectActionTypes.DELETE_SELECTED_PROJECT,
    payload: projId
})

export const addMultipleSelectedProjects = (projIdList) => ({
    type: ProjectActionTypes.ADD_MULTIPLE_SELECTED_PROJECTS,
    payload: projIdList
})

export const deleteMultipleSelectedProjects = (projIdList) => ({
    type: ProjectActionTypes.DELETE_MULTIPLE_SELECTED_PROJECTS,
    payload: projIdList
})

export const setSelectedProjects = (projIdList) => ({
    type: ProjectActionTypes.SET_SELECTED_PROJECT,
    payload: projIdList
})

export const setFilteredAndSortedProjects = (projects) => ({
    type: ProjectActionTypes.SET_FILTERED_AND_SORTED_PROJECTS,
    payload: projects
})

export const resetProjects = () => ({
    type: ProjectActionTypes.RESET_PROJECTS,
})
